import { useFetchNewNotificationCount } from './useFetchNewNotificationsCount';
import { useFilteredTimers } from './useFilteredTimers';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const useBadgeCounts = () => {
  const [refresh, setRefresh] = useState<string>();

  useEffect(() => {
    const handleTimersUpdated = (event: Event) => {
      const customEvent = event as CustomEvent<string>;
      setRefresh(customEvent.detail);
    };

    globalThis.addEventListener('timersUpdated', handleTimersUpdated);

    return () => {
      globalThis.removeEventListener('timersUpdated', handleTimersUpdated);
    };
  }, []);

  const { data: newNotificationCount } = useFetchNewNotificationCount({
    to: dayjs.utc(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
    from: dayjs.utc(new Date()).subtract(7, 'days').format('YYYY-MM-DD') + 'T00:00:00.000Z',
  });

  const { count: timerCount } = useFilteredTimers(undefined, refresh);

  const renderBadgeCount = (value: unknown) => {
    const count = Number(value);
    if (Number.isNaN(count)) {
      return 0;
    }
    if (count === 0) {
      return 0;
    }
    if (count > 9) {
      return '9+';
    }
    return count;
  };

  const notificationBadgeCount = renderBadgeCount(newNotificationCount);
  const timerBadgeCount = renderBadgeCount(timerCount);

  return { notificationBadgeCount, timerBadgeCount };
};
